import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

// Model
import { ResponseBase } from '../models/response-base';
import { TermoUso } from '../models/termo-uso';

@Injectable({
    providedIn: 'root'
})
export class TermoUsoService {
    APIProduto: string = environment.API + 'Portal/produtos';
    API: string = environment.API + 'Portal/termosuso';

    constructor(private http: HttpClient) { }

    getTermoUso(produtoGuid: string): Observable<ResponseBase<TermoUso>> {
        return this.http.get<ResponseBase<TermoUso>>(`${this.APIProduto}/${produtoGuid}/TermosUsos/recent`);
    }

    getTermoUsoContaCorrente(): Observable<ResponseBase<TermoUso>> {
        return this.http.get<ResponseBase<TermoUso>>(`${this.API}/contacorrente`);
    }
}
